<style scoped>
  .fin-bill {
    font-size: 14px;
    margin-left: 20px;
  }
</style>
<template>
  <div>
    {{ edit_title }}
    <span
      v-if="is_financer&&expense_group.accrued"
      class="fin-bill"
    >[预提单]</span>
    <span
      v-if="is_financer"
      class="fin-bill"
    >对应财务单据: {{ fin_bill_names || '无' }}</span>
    <!-- gen_by_contract -->
    <span
      v-if="expense_group.gen_by_contract"
      class="fin-bill"
      style="color:#ff9900"
    >
      [合同生成账单]
    </span>
  </div>
</template>
<script>
  import ExpenseUtil from '../../../../libs/expense_util';
  import FinBillUtil from '../../../fin_bill/libs/util';

  export default {
    props: {
      expense_group: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        failed: false
      }
    },
    computed: {
      is_financer() {
        return this.$store.getters.is_financer;
      },
      form_type() {
        return ExpenseUtil.getPaymentType(this.expense_group.payment_type);
      },
      edit_title() {
        return this.expense_group.id ? `编辑${this.form_type}单` : `添加${this.form_type}单`;
      },
      fin_bill_names() {
        if (!this.is_financer) return '';
        return FinBillUtil.expenseGroupFinBillNames(this.expense_group);
      }
    },
    watch: {
      'expense_group.payment_type'() {
        this.getFinBillKinds()
      },
      'expense_group.expense_payment_bank_id'() {
        this.getFinBillKinds()
      },
      // expense_group: {
      //   handler(newVal, oldVal) {
      //     if (newVal.payment_type !== oldVal.payment_type || newVal.expense_payment_bank_id !== oldVal.expense_payment_bank_id) {
      //       this.getFinBillKinds()
      //     }
      //   },
      //   deep: true
      // },
    },
    created() {
      //
    },
    mounted() {
      // this.getFinBillKinds()
      //
    },
    methods: {
      getFinBillKinds() {
        if (!this.is_financer) return;
        this.failed = false;
        this.loading = true;
        this.$http.get('expense_group/fin_bill_kinds', {
          payment_type: this.expense_group.payment_type,
          expense_payment_bank_id: this.expense_group.expense_payment_bank_id
        }).then((data) => {
          this.expense_group.fin_bill_kinds = data.fin_bill_kinds;
        
        }).catch((e) => {
          this.failed = true;
          console.log(e);
        }).finally(() => {
          this.loading = true;
        })
      }
    }
  }
</script>
